export default __webpack_public_path__ + "media/images/13-610c1e27cd2e20aa33e2348fbfdabeba.jpg";